import React, { useEffect, useRef, useState } from "react";
import { Copy, Share2 } from "lucide-react";
import LiveStandingsQrDownload from "./LiveStandingsQrDownload";
import "./MatchDownloads.css";

export default function MatchShareMenu({ match, family }) {
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState("");
  const root = useRef(null);
  const trigger = useRef(null);
  const url = `https://www.armorysync.com/matches/${family}/${encodeURIComponent(match.matchId)}`;
  useEffect(() => { setOpen(false); setMessage(""); }, [url]);
  useEffect(() => {
    if (!open) return undefined;
    const dismiss = event => { if (!root.current?.contains(event.target)) setOpen(false); };
    document.addEventListener("pointerdown", dismiss, true);
    return () => document.removeEventListener("pointerdown", dismiss, true);
  }, [open]);
  async function copy() {
    try { await navigator.clipboard.writeText(url); setMessage("Link copied"); }
    catch { setMessage("Select and copy the link below."); }
  }
  return <div ref={root} className="match-share" onBlur={event => { if (!event.currentTarget.contains(event.relatedTarget)) setOpen(false); }} onKeyDown={event => {
    if (event.key === "Escape" && open) { event.stopPropagation(); setOpen(false); trigger.current?.focus(); }
  }}>
    <button ref={trigger} className="match-download-trigger" type="button" aria-expanded={open} onClick={() => setOpen(value => !value)}><Share2 size={17} aria-hidden="true" />Share</button>
    {open && <div className="match-share-popover" role="group" aria-label="Share match">
      <button type="button" className="match-share-copy" onClick={copy}><Copy size={16} aria-hidden="true" />Copy match link</button>
      <LiveStandingsQrDownload match={match} family={family} />
      {message && <p role="status">{message}</p>}
      {message.startsWith("Select") && <input aria-label="Match link" readOnly value={url} onFocus={event => event.target.select()} />}
    </div>}
  </div>;
}
